import Keycloak from "keycloak-js";

let keycloakInstance = new Keycloak({
    "url": process.env.KEYCLOAK_HAPIMAG_URL || "https://development-welcome.hapimag.com/auth",
    "realm": process.env.KEYCLOAK_HAPIMAG_REALM || "hapimag-customer-experience",
    "clientId": process.env.KEYCLOAK_HAPIMAG_CLIENTID || "hapimag-spa"
});

export const keycloak = keycloakInstance;
